const isEmptyRow = (area) => !area?.goal?.category_name && !area?.name;

/**
 * Priority payload for the "Select Your Areas & Categories" rows.
 *
 * Rows are displayed sorted by goal.priority, but the API returns them in a
 * different order. Renumbering in API order rewrote every row's priority and
 * reshuffled the list after a Delete Row, so the row the user was looking at
 * appeared not to have been deleted (ARO-7398). Keep the current order, with
 * rows that have neither an area nor a category moved to the end.
 */
export const buildPriorityPayload = (areas) =>
  [...areas]
    .sort((a, b) => (a?.goal?.priority ?? 0) - (b?.goal?.priority ?? 0))
    .sort((a, b) => Number(isEmptyRow(a)) - Number(isEmptyRow(b)))
    .map((area, i) => ({ goal: area?.goal?.id, priority: i + 1 }));
